import React, { useState } from "react";
import ConfirmationModal from "../Confirmation Modal/confirmationModal";
import DinarHint from "../ui/DinarHint";

import { t } from "../../i18n";
const AddEmployeeModal = ({ isOpen, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: "",
    job: "",
    salary: "",
    phone: "",
  });

  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Validation for the name field (no numbers allowed)
    if (name === "name" && /\d/.test(value)) {
      setConfirmationMessage(t("الاسم يجب ألا يحتوي على أرقام!"));
      setIsConfirmationOpen(true);
      return;
    }

    // Validation for the job field (no numbers allowed)
    if (name === "job" && /\d/.test(value)) {
      setConfirmationMessage(t("الوظيفة يجب ألا تحتوي على أرقام!"));
      setIsConfirmationOpen(true);
      return;
    }

    // Validation for the salary field (only numbers allowed and minimum value of 0)
    if (name === "salary") {
      if (isNaN(value) || value < 0) {
        setConfirmationMessage(t("الراتب يجب أن يكون رقمًا ولا يكون أقل من 0!"));
        setIsConfirmationOpen(true);
        return;
      }
    }

    // Allow typing in the phone field without immediate validation
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, job, salary, phone } = formData;

    // Check if all fields are filled
    if (!name || !job || !salary || !phone) {
      setConfirmationMessage(t("جميع الحقول مطلوبة!"));
      setIsConfirmationOpen(true);
      return;
    }

    // Validate phone number format (only on submit)
    if (!/^(077|075|078)\d{8}$/.test(phone) || phone.length !== 11) {
      setConfirmationMessage(t("رقم الهاتف يجب أن يبدأ بـ 077 أو 075 أو 078 ويحتوي على 11 رقمًا!"));
      setIsConfirmationOpen(true);
      return;
    }

    // Save the form data
    onSave(formData);
    setFormData({
      name: "",
      job: "",
      salary: "",
      phone: "",
    });
    setConfirmationMessage(t("تم إضافة العامل بنجاح!"));
    setIsConfirmationOpen(true);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="modal-overlay">
        <div className="modal-panel md:max-w-[660px]" role="dialog" aria-modal="true">
          {/* Header */}
          <div className="bg-brand-600 text-white text-lg font-semibold px-6 py-4 rounded-t-2xl text-right">
            {t("إضافة عامل")}
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="p-6 space-y-4">
            {/* Name Field */}
            <div className="flex flex-col-reverse sm:flex-row ltr:sm:flex-row-reverse sm:items-center gap-1.5 sm:gap-4">
              <input
                type="text"
                name="name"
                placeholder={t("ادخل الاسم")}
                value={formData.name}
                onChange={handleChange}
                className="field sm:w-3/4"
                required
              />
              <label className="text-slate-700 text-sm md:text-base font-medium text-right sm:w-1/4">
                {t("الاسم")}
              </label>
            </div>

            {/* Job Field */}
            <div className="flex flex-col-reverse sm:flex-row ltr:sm:flex-row-reverse sm:items-center gap-1.5 sm:gap-4">
              <input
                type="text"
                name="job"
                placeholder={t("ادخل الوظيفة")}
                value={formData.job}
                onChange={handleChange}
                className="field sm:w-3/4"
                required
              />
              <label className="text-slate-700 text-sm md:text-base font-medium text-right sm:w-1/4">
                {t("الوظيفة")}
              </label>
            </div>

            {/* Salary Field */}
            <div className="flex flex-col-reverse sm:flex-row ltr:sm:flex-row-reverse sm:items-center gap-1.5 sm:gap-4">
              <div className="sm:w-3/4">
                <input
                  type="number"
                  name="salary"
                  placeholder={t("ادخل الراتب")}
                  value={formData.salary}
                  onChange={handleChange}
                  className="field"
                  min="0"
                  required
                />
                <DinarHint value={formData.salary} />
              </div>
              <label className="text-slate-700 text-sm md:text-base font-medium text-right sm:w-1/4">
                {t("الراتب (بالألف)")}
              </label>
            </div>

            {/* Phone Field */}
            <div className="flex flex-col-reverse sm:flex-row ltr:sm:flex-row-reverse sm:items-center gap-1.5 sm:gap-4">
              <input
                type="text"
                name="phone"
                placeholder={t("ادخل رقم الهاتف")}
                value={formData.phone}
                onChange={handleChange}
                className="field sm:w-3/4"
                required
              />
              <label className="text-slate-700 text-sm md:text-base font-medium text-right sm:w-1/4">
                {t("رقم الهاتف")}
              </label>
            </div>
          </form>

          {/* Footer */}
          <div className="bg-slate-50 border-t border-slate-200 flex flex-wrap justify-end px-6 py-4 rounded-b-2xl gap-3">
            <button
              type="button"
              onClick={onClose}
              className="bg-card text-slate-700 border border-slate-300 px-4 py-2 rounded-lg font-medium hover:bg-slate-100"
            >
              {t("إلغاء")}
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
              className="bg-brand-600 text-white px-4 py-2 rounded-lg font-medium shadow-sm hover:bg-brand-700 disabled:opacity-60"
            >
              {t("حفظ")}
            </button>
          </div>
        </div>
      </div>

      {/* Confirmation Modal */}
      <ConfirmationModal
        isOpen={isConfirmationOpen}
        message={confirmationMessage}
        onConfirm={() => setIsConfirmationOpen(false)}
      />
    </>
  );
};

export default AddEmployeeModal;
